import { DeviceType } from '../../device-api/device-type';
import { HTML5LocalStorage } from '../../device-api/html5-local-storage';
import { Deeplink } from '../../device-api/deeplink';
import { BrowserCapabilities } from './browser-capabilities';
import { BrowserInfo } from './browser-info';
import { BrowserInput } from './browser-input';
import { BrowserLifecycle } from './browser-lifecycle';
import { BrowserNetworkStatus } from './browser-network-status';
import { BrowserTelemetry } from './browser-telemetry';
import { BrowserDisplay } from './browser-display';
/**
 * @deprecated Use the createBrowserDevice function instead.
 */
export class BrowserDeviceFactory {
    initialise() {
        const input = new BrowserInput(self);
        const storage = new HTML5LocalStorage(self);
        const deviceInfo = new BrowserInfo(storage, self);
        const capabilities = new BrowserCapabilities(/safari/i.test(deviceInfo.browserName));
        const networkStatus = new BrowserNetworkStatus(self);
        const lifecycle = new BrowserLifecycle(self);
        const telemetry = new BrowserTelemetry(self);
        const display = new BrowserDisplay(deviceInfo);
        const deeplink = new Deeplink(self);
        return deviceInfo.initialise().then(() => ({
            type: DeviceType.Browser,
            input,
            deviceInfo,
            capabilities,
            storage,
            networkStatus,
            lifecycle,
            telemetry,
            display,
            deeplink,
        }));
    }
}
/**
 * Creates and initializes a BrowserDeviceFactory.
 */
export function createBrowserDevice() {
    const factory = new BrowserDeviceFactory();
    return factory.initialise();
}
//# sourceMappingURL=browser-device-factory.js.map